﻿import React from 'react';

import {
    DynamicFormToggleableRow,
    connectToggleable
} from './DynamicFormToggleableRow';

import {
    DynamicFormRow,
    Level2RowContainer,
    Level2RowContainerNoStripes,
    Level2RowButtonContainer,
    RepeatGroupButton,
    GroupRepetitionButton
} from '../Styles/dynamicFormStyles';

import DynamicFormLevel2QuestionRow from './DynamicFormLevel2QuestionRow';

import {repeatableIdSeparator} from '../constants';

class DynamicFormLevel1QuestionRow extends DynamicFormToggleableRow {
    render() {
        const QuestionTypeHandler = this.props.questionTypeHandler;
        const questionGroupId = this.props.isRepeated
            ? `${this.props.questionGroup.id}${repeatableIdSeparator}${this.props.repeatCount}`
            : this.props.questionGroup.id;

        const questionGroup = {
            ...this.props.questionGroup,
            id: questionGroupId
        };

        const subQuestionGroup = typeof this.props.questionGroup.subQuestionGroup !== 'undefined'
            && this.props.questionGroup.subQuestionGroup
                ? this.props.questionGroup.subQuestionGroup
                : null;

        const subGroupIsRepeatable = subQuestionGroup && subQuestionGroup.repeatable;
        const subGroupIsRepeated = subQuestionGroup && subQuestionGroup.id in this.props.repeatedInputs;
        const repeatCount = subGroupIsRepeated
            ? this.props.repeatedInputs[subQuestionGroup.id]
            : 0;

        const useStripedLayout = !(subQuestionGroup && subQuestionGroup.title);
        const RowContainer = useStripedLayout ? Level2RowContainer : Level2RowContainerNoStripes;

        let RepeatButton = null;
        if(subGroupIsRepeatable) {
            RepeatButton = () => (
                <GroupRepetitionButton
                    onClick={(e) => {
                        e.preventDefault();
                        this.props.repeatQuestionGroup(subQuestionGroup);
                    }}
                >
                    {
                        subQuestionGroup.addRepetitionButtonLabel !== null ?
                            subQuestionGroup.addRepetitionButtonLabel
                            :
                            "Lägg till fält"
                    }
                </GroupRepetitionButton>
            );
        }

        return (
            <div>
                <DynamicFormRow styleForConfirmView={this.props.currentStep === 1}>
                    <QuestionTypeHandler
                        question={questionGroup}
                        formInput={this.props.formInputs[questionGroupId]}
                        toggleSubQuestions={this.toggleSubQuestions}
                    />
                </DynamicFormRow>

                <RowContainer displayValue={this.state.subQuestionVisibility && subQuestionGroup !== null ? 'block' : null}>
                    {subQuestionGroup && this.state.subQuestionVisibility &&
                        subQuestionGroup.questions.map(group => (
                            <DynamicFormLevel2QuestionRow
                                key={group.id}
                                questionGroup={group}
                                styleForConfirmView={this.props.currentStep === 1}
                                questionTypeHandler={QuestionTypeHandler}
                                isRepeated={false}

                                formInputs={this.props.formInputs}
                                addQuestionGroupInputs={this.props.addQuestionGroupInputs}
                                removeQuestionGroupInputs={this.props.removeQuestionGroupInputs}
                            />
                        ))
                    }

                    {subGroupIsRepeatable && repeatCount === 0 && this.props.currentStep == 0 &&
                        <Level2RowButtonContainer transparentBackground={true} noBorder={!useStripedLayout} rightAlign={true}>
                            <RepeatButton />
                        </Level2RowButtonContainer>
                    }
                </RowContainer>

                {subGroupIsRepeated && subQuestionGroup !== null && subQuestionGroup.questions.length && this.state.subQuestionVisibility &&
                    <React.Fragment>
                        {[...Array(repeatCount)].map((_, i) =>
                            <React.Fragment key={i}>
                                <RowContainer
                                    alternateBackground={useStripedLayout}
                                    displayValue={this.state.subQuestionVisibility && subQuestionGroup !== null ? 'block' : null}
                                >
                                    {subQuestionGroup.questions.map((group, j) => (
                                        <DynamicFormLevel2QuestionRow
                                            key={(this.props.formInputs[`${group.id}${repeatableIdSeparator}${(i+1)}`].uniqueKeyId || `${group.id}-${i}`) + '-' + j}
                                            questionGroup={group}
                                            questionTypeHandler={QuestionTypeHandler}
                                            isRepeated={true}
                                            repeatCount={i+1}

                                            repeatedInputs={this.props.repeatedInputs}
                                            formInputs={this.props.formInputs}
                                            addQuestionGroupInputs={this.props.addQuestionGroupInputs}
                                            removeQuestionGroupInputs={this.props.removeQuestionGroupInputs}
                                        />
                                    ))}
                                    {subGroupIsRepeatable && this.props.currentStep == 0 && (
                                        <Level2RowButtonContainer 
                                            noSidePadding={true} 
                                            noTopPadding={true} 
                                            transparentBackground={true} 
                                            noBorder={true} 
                                            rightAlign={true}
                                        >
                                            <GroupRepetitionButton
                                                removeIcon={true}
                                                onClick={(e) => {
                                                    e.preventDefault();
                                                    const repeatableIndex = (i+1);
                                                    this.props.removeRepeatedQuestionGroup(subQuestionGroup, repeatableIndex);
                                                }}
                                            >
                                            {
                                                subQuestionGroup.deleteRepetitionButtonLabel !== null ?
                                                subQuestionGroup.deleteRepetitionButtonLabel
                                                :
                                                "Ta bort fält"
                                            }
                                            </GroupRepetitionButton>
                                        </Level2RowButtonContainer>
                                    )}
                                </RowContainer>

                                {repeatCount == (i + 1) && this.props.currentStep == 0 && // show if last item
                                    <Level2RowButtonContainer
                                        noTopPadding={true}
                                        alternateBackground={useStripedLayout}
                                        transparentBackground={!useStripedLayout}
                                        rightAlign={true}
                                    >
                                        <RepeatButton />
                                    </Level2RowButtonContainer>
                                }
                            </React.Fragment>
                        )}
                    </React.Fragment>
                }
            </div>
        );
    }
}

export default connectToggleable(DynamicFormLevel1QuestionRow);
